export function hasAnyPermission(permissions, required) {
    return required.some((perm) => permissions.includes(perm));
}
export function hasPermission(permissions, required) {
    return permissions.includes(required);
}
